import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../Checkbox'
import { FormModal, formValidationSchemaNoChanged } from '../../../Form'
import { FormikField, getFormikCheckboxFieldValueProps } from '../../../Formik'
import {
  isFormCommentsFieldsEqual,
  REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT,
  REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE,
  REQUEST_EDIT_USER_COMMENT_MODAL_BOX_SIZE,
  REQUEST_EDIT_USER_COMMENT_MODAL_QA_NAME,
  RequestEditUserCommentFields,
} from '../../../Request'
import { useRequestProfileContext } from '../../RequestProfile.hooks'

import * as styles from './RequestProfileWidgetSendNotificationField.module.css'

function RequestProfileWidgetSendNotificationField({
  checkboxFieldName,
  commentFieldName,
  disabledTooltipKey,
  fieldName,
  requestId,
}) {
  const { t } = useTranslation()

  const { setValues, values } = useFormikContext()

  const { handleCloseModal, setModal } = useRequestProfileContext()

  const disabled = values[fieldName].length === 0

  const initialValues = {
    ...REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE,
    [REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT]:
      values[commentFieldName],
  }

  function handleSaveNoticeValues({ values: noticeValues }) {
    setValues({
      ...values,
      [checkboxFieldName]: true,
      [commentFieldName]:
        noticeValues[REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT],
    })

    handleCloseModal()
  }

  function handleOpenNoticeModal() {
    setModal(
      <FormModal
        Fields={RequestEditUserCommentFields}
        containerProps={{
          boxSize: REQUEST_EDIT_USER_COMMENT_MODAL_BOX_SIZE,
          qaName: REQUEST_EDIT_USER_COMMENT_MODAL_QA_NAME,
        }}
        formBodyProps={{
          withNotifications: true,
        }}
        formFieldsProps={{ id: requestId }}
        formTitle='Modal.SendInvitationTitleKey'
        initialValues={initialValues}
        validationSchema={formValidationSchemaNoChanged({
          initialValues,
          isEqual: isFormCommentsFieldsEqual,
        })}
        onClose={handleCloseModal}
        onSubmit={handleSaveNoticeValues}
      />
    )
  }

  return (
    <FormikField
      showTooltip
      Component={Checkbox}
      Field={Fragment}
      buttonProps={{
        text: t('Modal.TextViewBtnKey'),
        onClick: handleOpenNoticeModal,
      }}
      disabled={disabled}
      getValueProps={getFormikCheckboxFieldValueProps}
      label={t('Modal.SendNotificationLabelKey')}
      labelClassName={styles.checkboxLabel}
      labelTitleClassName={styles.checkboxLabelTitle}
      name={checkboxFieldName}
      size={CHECKBOX_SIZE.small}
      tooltip={disabled ? t(disabledTooltipKey) : null}
      type={CHECKBOX_TYPE.action}
    />
  )
}

export default RequestProfileWidgetSendNotificationField
